import { API, getAsyncThunk } from 'app/api';
import { addBetFactory } from 'app/modules/BetSlip/actions/addBetFactory';

import { matches, objects, sports } from '../selectors/entities';

// ---

export const fetchLiveMainLine = getAsyncThunk('FETCH:LIVE_MAINLINE_MATCHES', API.matches.getLiveMainLine);
export const fetchLive = getAsyncThunk('FETCH:LIVE_MATCHES', API.matches.getLive);

// ---

export const addBet = addBetFactory(matches, sports, objects);
